import {
    Box,
    Button,
    Checkbox,
    Divider,
    Flex,
    Input,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Radio,
    RadioGroup,
    Select,
    Spinner,
    Switch,
    Table,
    Tbody,
    Td,
    Text,
    Textarea,
    Th,
    Thead,
    Tooltip,
    Tr,
    useColorModeValue,
    useDisclosure,
    useToast
} from '@chakra-ui/react';
import DriveModal from 'components/drive/DriveModal';
import { useFormik } from 'formik';
import { useState } from 'react';
import PhoneInput from 'react-phone-input-2';
import { useUpdatePublishAdMutation } from 'store/publishTracking/trackingApi';
import * as Yup from 'yup';

import BuildUrlParamCarousel from '../BuildUrlParamCarousel';
import BuildUrlParamsUpdate from '../BuildUrlParamsUpdate';

import { InfoOutlineIcon } from '@chakra-ui/icons';
import { useGetInstantFormsByPageIdQuery } from 'store/campaigns/adsApi';
import { useGetAdvertisableAppsQuery } from 'store/campaigns/adsetFormApi';
import {
    call_to_action_options,
    call_to_action_options_app_promptions,
    call_to_action_options_Awareness_Traffic_Engagement,
    call_to_action_options_for_app_leads_and_sales,
    call_to_action_options_instantForms,
    call_to_action_options_whatsapp
} from 'utils/callToActions';
import { removeEmptyValues } from 'utils/functions';
import FaceBookPageSelector from '../FaceBookPageSelector';
import InstagramAccountSelector from '../InstagramAccountSelector';
import UrlParametersUpdate from '../UrlParametersUpdate';
import PublishAdPreviewCarousel from './PublishAdPreviewCarosuel';
import MessageTemplateModal from 'components/genericForms/MessageTemplateModal';
import { MdOutlineEdit } from 'react-icons/md';

const CarouselPublishAdupdate = ({ targeting, trackingData, onClose, onSaveSuccess }) => {

    const { adsAccount, form, _id, adset, campaign } = trackingData;
    const background = useColorModeValue('gray.50', 'gray.800');
    const backgroundColor = useColorModeValue('#F5F3F9', '#1e1530');
    const toast = useToast();
    const [isDriveModalOpen, setIsDriveModalOpen] = useState(false);
    const [selectedMedia, setSelectedMedia] = useState(null);
    const [isEnabled, setIsEnabled] = useState(false);
    const [isUrlModalOpen, setUrlModalOpen] = useState(false);
    const [isSingleUrlModalOpen, setSingleUrlModalOpen] = useState(false);
    const [isUrlParamModalOpen, setUrlParamModalOpen] = useState(false);
    const [selectedFileIndex, setSelectedFileIndex] = useState(null);
    const { isOpen: isMessageModalOpen, onOpen: onMessageModalOpen, onClose: onMessageModalClose } = useDisclosure();

    const [selectedCreativeIndex, setSelectedCreativeIndex] = useState(null);

    const [updatePublishAd] = useUpdatePublishAdMutation();

    const pageId = adset?.promoted_object?.page_id;

    const formattedPageIds = Array.isArray(pageId) ? pageId : [pageId];

    const { data: instantForms } = useGetInstantFormsByPageIdQuery(
        { pageIds: formattedPageIds },
        { skip: !formattedPageIds.length || adset?.destination_type !== 'ON_AD' }
    );

    const { data: advertisableApps } = useGetAdvertisableAppsQuery({adsAccountId: adsAccount.adsAccountId}, {skip: !adsAccount.adsAccountId});

    let pageIdToSend = null;

    if (
        ((adset?.destination_type === "PHONE_CALL" ||
        campaign?.objective === "OUTCOME_AWARENESS" ||
        adset?.destination_type === "ON_PAGE" ||
        adset?.destination_type === "WHATSAPP") && pageId)
    ) {
        pageIdToSend = pageId;
    }  

    const validationSchema = Yup.object().shape({
        name: Yup.string().required('Ad Name is required'),
        identity: Yup.object().shape({
            page_id: Yup.string().required('Facebook Page is required'),
        }),
        type: Yup.string().required('Type is required'),
        link: Yup.string()
            .when('destinationType', {
                is: (value) => ['WEBSITE', 'OUTCOME_AWARENESS'].includes(value),
                then: () => Yup.string()
                    .required('URL is required'),
                otherwise: () => Yup.string().notRequired(),
            }),
        // phoneNumber: Yup.string().
        //     when('type', {
        //         is: (value) => value === 'CALL_NOW',
        //         then: () => Yup.string()
        //             .transform((value) => value.slice(2)) // Remove the first two digits (e.g., country code like "91")
        //             .matches(/^[0-9]{10,15}$/, 'Phone number must be at least 10 digits') // Ensure remaining digits are at least 10 digits
        //             .required('Phone number is required'), // Ensure phone number is provided
        //         otherwise: () => Yup.string().notRequired(),
        // }),
        adcreative: Yup.array().of(
            Yup.object().shape({
                //message: Yup.string().required('Message is required'),
                name: Yup.string(),
                description: Yup.string(),
                //type: Yup.string().required('Type is required'),
                link: Yup.string()
                    .when('destinationType', {
                        is: (value) => ['WEBSITE', 'OUTCOME_AWARENESS'].includes(value),
                        then: () => Yup.string()
                            .required('URL is required'),
                        otherwise: () => Yup.string().notRequired(),
                    }),
            })
        )
    });

    const formik = useFormik({
        initialValues: {
            name: form?.name || "",
            message: form?.message || "",
            cpa: form?.cpa || "",
            description: form?.description || "",
            type: form?.type || "",
            link: form?.link || "",
            app_product_page_id: form?.asset_feed_spec?.app_product_page_id || "",
            phoneNumber: form?.link?.includes('tel:+') ? form?.link.replace('tel:+', '') : '',
            url_tags: form?.url_tags || '',
            identity: {
                page_id: form.identity?.page_id || "",
                instagram_user_id: form?.identity?.instagram_user_id || "",
            },
            destinationType: campaign?.objective === "OUTCOME_AWARENESS" ? "OUTCOME_AWARENESS" : adset?.destination_type,
            enroll_status: form?.contextual_multi_ads?.enroll_status ? form?.contextual_multi_ads?.enroll_status : 'OPT_OUT',
            caption: form?.caption || '',
            app_id: form?.template_url_spec?.config?.app_id || '',
            page_welcome_message: form?.page_welcome_message,
            adcreative: form.adcreative.map(creative => ({
                _id: creative._id || "",
                destinationType: campaign?.objective === "OUTCOME_AWARENESS" ? "OUTCOME_AWARENESS" : adset?.destination_type,
                message: creative.message || "",
                name: creative.name || "",
                description: creative.description || "",
                type: creative.type ? creative.type : "CALL_NOW",
                link: creative.link || "",
                hash: creative?.hash || "",
                image_hash: creative.image_hash || "",
                url: creative.url || "",
                video_id: creative?.video_id || "",
                thumbnail: creative?.thumbnail || "",
                caption: creative?.caption || "",
            })),
        },
        validationSchema,
        onSubmit: (values, { setSubmitting }) => {

            const formatPhoneNumber = (phoneNumber) => {

                if (!phoneNumber.startsWith('tel:+')) {
                    return `tel:+${phoneNumber}`;
                }
                return phoneNumber;
            };

            const payload = {
                name: values?.name,
                message: values?.message,
                cpa: values?.cpa,
                description: values?.description,
                type: values?.type,
                link: values?.type === "CALL_NOW"
                    ? `tel:+${values?.adcreative[values?.adcreative.length - 1]?.link}`
                    : values?.link,
                ...(values?.url_tags?.trim() && { url_tags: values.url_tags }),
                asset_feed_spec: {
                    app_product_page_id: values.app_product_page_id,
                },
                identity: {
                    page_id: values.identity.page_id,
                    ...(values?.identity?.instagram_user_id.trim() && {
                        instagram_user_id: values?.identity?.instagram_user_id,
                    }),
                },
                ...(campaign?.objective === "OUTCOME_AWARENESS" && {
                    template_url_spec: { config: { app_id: values.app_id } },
                    // degrees_of_freedom_spec: {
                    //   creative_features_spec: {
                    //     standard_enhancements: { enroll_status: "OPT_OUT" },
                    //   },
                    // },
                }),
                ...((['WHATSAPP'].includes(adset?.destination_type)) && { page_welcome_message: values?.page_welcome_message }),
                ...(values.type !== 'CALL_NOW' && {caption: values.caption}),
                adcreative: values.adcreative.map((creative, index) => {
                    return {
                        link: creative?.type === 'CALL_NOW'
                            ? formatPhoneNumber(creative?.link)
                            : creative?.link,
                        url: creative?.url,
                        name: creative?.name,
                        message: creative?.message,
                        caption: creative?.caption,
                        type: values?.type,
                        description: creative?.description,
                        ...(creative?.video_id && {
                            video_id: creative?.video_id,
                            thumbnail: creative?.thumbnail,
                            hash: creative?.hash,

                        }),
                        ...(creative?.image_hash && {
                            image_hash: creative?.image_hash,
                            url: creative?.url,
                            hash: creative?.hash,
                        }),
                    };
                }),
            };

            const filteredPayload = removeEmptyValues(payload);

            updatePublishAd({ trackingId: _id, payload: filteredPayload })
                .unwrap()
                .then(response => {
                    onSaveSuccess();
                    toast({
                        position: "top-right",
                        title: "Ads updated",
                        status: "success",
                        duration: 4000,
                        isClosable: true,
                    });
                })
                .catch(error => {
                    toast({
                        position: "top-right",
                        title: "Error updating ads",
                        status: "error",
                        duration: 4000,
                        isClosable: true,
                    });
                })
                .finally(() => {
                    setSubmitting(false);
                    onClose();
                });
        },
    });

    const handleOpenDriveModal = (mediaType, index) => {
        setSelectedMedia(mediaType);
        setSelectedCreativeIndex(index); // Set the index of the creative being edited
        setIsDriveModalOpen(true);
    };

    const handleMediaSelect = (file) => {
        if (file && file?.length > 0 && selectedCreativeIndex !== null) {
            const selectedFile = file[0];
            formik.setFieldValue('adcreative', formik.values?.adcreative?.map((creative, index) => {
                if (index === selectedCreativeIndex) {
                    return {
                        ...creative,
                        ...(selectedMedia === 'image' && {
                            image_hash: selectedFile?.creativeId,
                            hash: selectedFile?.hash,
                            url: selectedFile?.url,
                        }),
                        ...(selectedMedia === 'video' && {
                            video_id: selectedFile?.creativeId,
                            hash: selectedFile?.hash,
                            thumbnail: selectedFile?.picture,
                        }),
                    };
                }
                return creative;
            }));
        }
        setIsDriveModalOpen(false);
        setSelectedCreativeIndex(null);
    };

    const handleUrlChange = (constructedUrl) => {
        formik.setFieldValue('link', constructedUrl);
    };

    const handleSingleUrlChange = (constructedUrl, fileIndex) => {

        // Make a copy of the current child_attachments array
        const updatedChildAttachments = [...formik.values.adcreative];

        // Update the 'link' of the specific fileIndex
        updatedChildAttachments[fileIndex] = {
            ...updatedChildAttachments[fileIndex],
            link: constructedUrl,
        };

        // Now use Formik's setFieldValue to update the form field
        formik.setFieldValue(
            "adcreative",
            updatedChildAttachments
        );
    };

    const handleUrlParamChange = (constructedUrl) => {
        formik.setFieldValue('url_tags', constructedUrl);
    };

    const filteredInstantForms = instantForms?.length > 0 && instantForms
        .map((formResponse) => formResponse?.data?.data) // Get the 'data' array from each formResponse
        .flat() // Flatten the array to get all forms in one array
        .filter((form) => form?.page_id === pageId);

    if (!form) {
        return <Spinner mt={'20px'} />;
    }

    return (
        <form onSubmit={formik.handleSubmit}>
            <Flex gap={4}>
                <Flex direction={'column'} flex={0.4}>
                    <Flex direction={'column'} gap={4} borderRadius="md" bg={background} p={4} mb={4}>
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Ad Name</Text>
                            <Input
                                name="name"
                                placeholder="Enter ad name"
                                size='sm'
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.name}
                            />
                            {formik.touched.name && formik.errors.name && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.name}</Text>
                            )}
                        </Flex>

                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Facebook Page</Text>
                             <FaceBookPageSelector
                                adsAccount={{
                                    account_id: adsAccount.adsAccountId,
                                    name: adsAccount.adsAccountName
                                }}
                                pageIdToSend={pageIdToSend ? pageIdToSend : ''}
                                selectedPageId={formik?.values?.identity?.page_id}
                                onSelectedPage={(pageId) => {
                                    formik.setFieldValue('identity.page_id', pageId);

                                    // Reset the Instagram actor ID to an empty string
                                    formik.setFieldValue('identity.instagram_user_id', '');
                                }}
                            />
                            {formik.errors.identity?.page_id && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.identity?.page_id}</Text>
                            )}
                        </Flex>

                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Instagram accounts</Text>
                            <InstagramAccountSelector
                                adsAccount={adsAccount}
                                selectedInstPageId={formik?.values?.identity?.instagram_user_id}
                                onSelectedPage={(pageId) => {
                                    formik.setFieldValue('identity.instagram_user_id', pageId);
                                }}
                                pageID={formik?.values?.identity?.page_id}
                            />
                        </Flex>
                        <Divider />

                        {/* Multi-advertiser ads Section */}
                        <Flex direction="column" borderRadius="md" gap={2}>
                            <Checkbox
                                onChange={(e) => {
                                    formik.setFieldValue("enroll_status", e.target.checked ? 'OPT_IN' : 'OPT_OUT');
                                }}
                                colorScheme="brand"
                                isChecked={formik.values.enroll_status === 'OPT_IN'}
                            >
                                <Flex align={'center'}>
                                    <Text fontWeight="bold" fontSize={'14px'}>Multi-advertiser ads &nbsp;</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Your ads can appear alongside other ads in the same ad unit to help people discover products and services from businesses that are personalized to them. Your ad creative may be resized or cropped to fit the ad unit.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                            </Checkbox>
                        </Flex>
                    </Flex>

                    <Flex direction={'column'} gap={4} borderRadius="md" bg={background} p={4} mb={4}>
                        {formik.values.adcreative.map((creative, index) => (
                            <Flex direction={'column'} gap={'20px'} key={index} borderWidth={1} borderRadius="md" p={4}>
                                <Flex direction="column" gap={1}>
                                    <Text fontWeight="bold">Headline</Text>
                                    <Input
                                        name={`adcreative.${index}.name`}
                                        placeholder="Write a short headline"
                                        size='sm'
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.adcreative[index].name}
                                    />
                                    {formik.touched.adcreative?.[index]?.name && formik.errors.adcreative?.[index]?.name && (
                                        <Text fontSize={"12px"} color="red.500">{formik.errors.adcreative[index].name}</Text>
                                    )}
                                </Flex>

                                {adset?.destination_type === 'APP' ? null :
                                    <Flex direction="column" gap={1}>
                                        <Text fontWeight="bold">Description</Text>
                                        <Textarea
                                            name={`adcreative.${index}.description`}
                                            placeholder="Enter description"
                                            size='sm'
                                            borderRadius="md"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.adcreative[index].description}
                                        />
                                        {formik.touched.adcreative?.[index]?.description && formik.errors.adcreative?.[index]?.description && (
                                            <Text fontSize={"12px"} color="red.500">{formik.errors.adcreative[index].description}</Text>
                                        )}
                                    </Flex>
                                }

                                {formik.values.adcreative?.[index]?.type === 'CALL_NOW' ? (
                                    <Flex direction="column" gap={1}>
                                        <Text fontWeight="bold">Call to action</Text>
                                        <Select
                                            name={`adcreative.${index}.type`}
                                            size="sm"
                                            borderRadius="md"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.adcreative[index].type}
                                            isDisabled
                                        >
                                            <option value="CALL_NOW">Call Now</option>
                                        </Select>
                                        {formik.touched.adcreative?.[index]?.type && formik.errors.adcreative?.[index]?.type && (
                                            <Text fontSize={"12px"} color="red.500">{formik.errors.adcreative[index].type}</Text>
                                        )}
                                    </Flex>
                                ) : null}

                                {formik.values.adcreative?.[index]?.type === 'CALL_NOW' ? (
                                    <Flex direction="column" gap={1}>
                                        <Text fontWeight="bold">Phone Number</Text>
                                        <PhoneInput
                                            name={`adcreative.${index}.link`}
                                            value={formik.values.adcreative[index].link}
                                            onChange={(value) => formik.setFieldValue(`adcreative.${index}.link`, value)}
                                            country={'in'}
                                        />
                                        {formik.touched.adcreative?.[index]?.link && formik.errors.adcreative?.[index]?.link && (
                                            <Text fontSize={"12px"} color="red.500">{formik.errors.adcreative[index].link}</Text>
                                        )}
                                    </Flex>
                                ) : (null)}

                                {adset?.destination_type === 'WEBSITE' || campaign?.objective === "OUTCOME_AWARENESS" ? (
                                    <Flex direction="column" gap={1}>
                                        <Text fontWeight="bold">Website URL</Text>
                                        <Input
                                            name={`adcreative.${index}.link`}
                                            placeholder="Enter link URL"
                                            size='sm'
                                            borderRadius="md"
                                            onBlur={formik.handleBlur}
                                            value={formik.values.adcreative[index].link}
                                            onChange={formik.handleChange}
                                        />
                                        <Flex mt={2}>
                                            <Button onClick={() => {
                                                setSingleUrlModalOpen(true)
                                                setSelectedFileIndex(index)
                                            }}
                                                variant="link"
                                                color='brand'>
                                                <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                            </Button>
                                        </Flex>
                                        {formik.touched.adcreative?.[index]?.link && formik.errors.adcreative?.[index]?.link && (
                                            <Text fontSize={"12px"} color="red.500">{formik.errors.adcreative[index].link}</Text>
                                        )}
                                    </Flex>
                                ) : (null)}

                                {adset?.destination_type === 'APP' && campaign?.objective === 'OUTCOME_APP_PROMOTION' ? (
                                    <Flex direction="column" gap={1}>
                                        <Flex alignItems="center" gap={2}>
                                            <Text fontWeight="bold" fontSize={'14px'}>Deferred deep link</Text>
                                            <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="sm" p="5px">
                                                        <Text fontWeight={'bold'}>Using a deferred deep link</Text><br></br>
                                                        <Text mb={2}>A deferred deep link is a URL that sends people to your app in the respective app store. Once people install your app, the link will take them to a specific screen, such as a product page.</Text>
                                                        <Text mb={2}>To use a deferred deep link, you need to first connect the Facebook SDK. You can use any of these link types:</Text>
                                                        <Box>
                                                            <Text>* Android app link</Text>
                                                            <Text>* Custom URL scheme</Text>
                                                            <Text>* Facebook app link</Text>
                                                        </Box>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Input
                                            name={`adcreative.${index}.link`}
                                            placeholder="Enter a deferred deep link URL"
                                            size='sm'
                                            borderRadius="md"
                                            onBlur={formik.handleBlur}
                                            value={formik.values.adcreative[index].link}
                                            onChange={formik.handleChange}
                                        />
                                    </Flex>
                                ) : (null)}

                                {adset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(campaign?.objective) ? (
                                    <Flex direction="column" gap={1}>
                                        <Flex alignItems="center" gap={2}>
                                            <Text fontWeight="bold" fontSize={'14px'}>Deep link</Text>
                                            <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                            <Tooltip
                                                borderRadius={5}
                                                label={
                                                    <Box fontSize="sm" p="5px">
                                                       <Text>Send people to a specific place in your app. You can use an Apple universal link, Android App Link, custom URL scheme or Facebook App Link.</Text>
                                                    </Box>
                                                }
                                                fontSize="md"
                                            >
                                                <InfoOutlineIcon pointerEvents="all" />
                                            </Tooltip>
                                        </Flex>
                                        <Input
                                            name={`adcreative.${index}.link`}
                                            placeholder="Enter the deep link URL"
                                            size='sm'
                                            borderRadius="md"
                                            onBlur={formik.handleBlur}
                                            value={formik.values.adcreative[index].link}
                                            onChange={formik.handleChange}
                                        />
                                    </Flex>
                                ) : (null)}

                                {adset?.destination_type === 'WHATSAPP' &&  ['OUTCOME_SALES', 'OUTCOME_LEADS'].includes(campaign?.objective) &&  (formik.values.adcreative[index].video_id) ? 
                                    <Flex direction="column" gap={1}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Display link</Text>
                                        <Input
                                            name={`adcreative.${index}.caption`}
                                            placeholder="Enter the link you want to show on your ad"
                                            size='sm'
                                            borderRadius="md"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.adcreative[index].caption}
                                        />
                                    </Flex>
                                :null}

                                <Text fontWeight="bold">Ad creative</Text>
                                <Flex direction="row" gap={2} alignItems={'center'}>
                                    <img
                                        src={creative.image_hash ? creative.url : creative.thumbnail}
                                        alt="Thumbnail"
                                        style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '5px' }}
                                    />
                                    <Button
                                        bg={'gray.50'}
                                        size="xs"
                                        borderWidth={1}
                                        onClick={() => handleOpenDriveModal(creative.image_hash ? 'image' : 'video', index)}>
                                        {creative.image_hash ? "Change Image" : "Change Video"}
                                    </Button>
                                </Flex>
                            </Flex>
                        ))}
                    </Flex>

                    <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">Primary Text</Text>
                            <Textarea
                                name="message"
                                placeholder="Enter a text"
                                bg="#fff"
                                size='sm'
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.message}
                            />
                            {formik.touched.message && formik.errors.message && (
                                <Text fontSize={"12px"} color="red.500">{formik.errors.message}</Text>
                            )}
                        </Flex>

                        {adset?.destination_type !== 'PHONE_CALL' ? (
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Call to action</Text>
                                {adset?.destination_type === 'ON_AD' ? (
                                    <Select
                                        name={'type'}
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.type}
                                    >
                                        {call_to_action_options_instantForms?.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : adset?.destination_type === 'WHATSAPP' ? (
                                    <Select
                                        name={'type'}
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.type}
                                        isDisabled={campaign?.objective === 'OUTCOME_LEADS'}
                                    >
                                        {call_to_action_options_whatsapp?.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : adset?.destination_type === 'APP' && campaign?.objective === "OUTCOME_APP_PROMOTION" ? (
                                    <Select
                                        name={'type'}
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.type}
                                    >
                                        {call_to_action_options_app_promptions.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ): adset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(campaign?.objective) ? (
                                    <Select
                                        name={'type'}
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.type}
                                    >
                                        {call_to_action_options_for_app_leads_and_sales.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ): campaign?.objective === "OUTCOME_AWARENESS" || (["OUTCOME_ENGAGEMENT","OUTCOME_TRAFFIC"].includes(campaign?.objective) && adset?.destination_type === 'WEBSITE')  ? (
                                    <Select
                                        name="type"
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.type}
                                    >
                                        {call_to_action_options_Awareness_Traffic_Engagement?.map((option) => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                ) : 
                                    <Select
                                        name={'type'}
                                        size="sm"
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.type}
                                    >
                                        {call_to_action_options.map(option => (
                                            <option key={option.value} value={option.value}>
                                                {option.label}
                                            </option>
                                        ))}
                                    </Select>
                                }
                                {formik.touched.type && formik.errors.type && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors.type}</Text>
                                )}
                            </Flex>
                        ) : null}

                        {/* {formik.values.type === 'CALL_NOW' && (
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Phone Number</Text>
                                <PhoneInput
                                    name="phoneNumber"
                                    value={formik.values.phoneNumber}
                                    onChange={(value) => formik.setFieldValue('phoneNumber', value)}
                                    country={'in'}
                                />                        
                                {formik.errors?.phoneNumber && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors?.phoneNumber}</Text>
                                )}
                            </Flex>
                            )} */}

                        {adset?.destination_type === 'WEBSITE' || campaign?.objective === "OUTCOME_AWARENESS" ? (
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold">Website URL</Text>
                                <Input
                                    name="link"
                                    placeholder="Enter a URL"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.link}
                                    onChange={formik.handleChange}
                                />
                                <Flex mt={2}>
                                    <Button onClick={() => {
                                        setUrlModalOpen(true)
                                    }}
                                        variant="link"
                                        color='brand'>
                                        <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                    </Button>
                                </Flex>
                                {formik.errors.link && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors.link}</Text>
                                )}
                            </Flex>
                        ) : (null)}

                        {adset?.destination_type === 'APP' && campaign?.objective === 'OUTCOME_APP_PROMOTION' ? (
                            <>
                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Deferred deep link</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                    <Text fontWeight={'bold'}>Using a deferred deep link</Text><br></br>
                                                    <Text mb={2}>A deferred deep link is a URL that sends people to your app in the respective app store. Once people install your app, the link will take them to a specific screen, such as a product page.</Text>
                                                    <Text mb={2}>To use a deferred deep link, you need to first connect the Facebook SDK. You can use any of these link types:</Text>
                                                    <Box>
                                                        <Text>* Android app link</Text>
                                                        <Text>* Custom URL scheme</Text>
                                                        <Text>* Facebook app link</Text>
                                                    </Box>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="link"
                                        placeholder="Enter a deferred deep link URL"
                                        bg="#fff"
                                        size='sm'
                                        borderRadius="md"
                                        value={formik.values.link}
                                        onChange={formik.handleChange}
                                    />
                                </Flex>
                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Custom store listing</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                    <Text fontWeight={'bold'}>Using a custom store listing</Text><br></br>
                                                    <Text mb={2}>A custom store listing ID sends people who click your ad to a landing page that you've customised in the Google Play Store.</Text>
                                                    <Text mb={2}>Use this feature to create multiple custom product pages with different media and text that speak to your various audiences.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="app_product_page_id"
                                        placeholder="Enter custom store listing ID"
                                        size='sm'
                                        borderRadius="md"
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        value={formik.values.app_product_page_id}
                                    />
                                </Flex>
                            </>
                        ) : (null)}

                        {adset?.destination_type === 'APP' && ["OUTCOME_SALES", "OUTCOME_LEADS"].includes(campaign?.objective) ? (
                            <>
                                <Flex direction="column" gap={1}>
                                    <Flex alignItems="center" gap={2}>
                                        <Text fontWeight="bold" fontSize={'14px'}>Deep link</Text>
                                        <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                        <Tooltip
                                            borderRadius={5}
                                            label={
                                                <Box fontSize="sm" p="5px">
                                                   <Text>Send people to a specific place in your app. You can use an Apple universal link, Android App Link, custom URL scheme or Facebook App Link.</Text>
                                                </Box>
                                            }
                                            fontSize="md"
                                        >
                                            <InfoOutlineIcon pointerEvents="all" />
                                        </Tooltip>
                                    </Flex>
                                    <Input
                                        name="link"
                                        placeholder="Enter the deep link URL"
                                        bg="#fff"
                                        size='sm'
                                        borderRadius="md"
                                        value={formik.values.link}
                                        onChange={formik.handleChange}
                                    />
                                </Flex>
                            </>
                        ) : (null)}

                        {adset?.destination_type === 'ON_AD' ? (
                            <>
                                <Flex alignItems="center" gap={2} mt={2}>
                                    <Text fontWeight="bold">Instant form</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Make connections with people by letting them send contact information and other details to you through a form.</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>

                                {/* Table Layout */}
                                {filteredInstantForms?.length > 0 ? (
                                    <RadioGroup onChange={(value) => formik.setFieldValue('link', value)} value={formik.values.link} colorScheme="brand">
                                        <Table variant="simple">
                                            <Thead>
                                                <Tr>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px">Form title</Th>
                                                    <Th textTransform={'none'} color={'none'} fontSize="14px">Creation date</Th>
                                                </Tr>
                                            </Thead>
                                            <Tbody>
                                                {filteredInstantForms?.map((form) => (
                                                    <Tr key={form?.id}>
                                                        <Td>
                                                            <Flex alignItems="center" gap={2}>
                                                                <Radio value={form?.id} />
                                                                <Text color={form.status === 'DRAFT' ? "gray.500" : "none"} fontSize={'12px'}>
                                                                    {form?.name}
                                                                </Text>
                                                            </Flex>
                                                        </Td>
                                                        <Td>
                                                            <Text fontSize={'12px'}>
                                                                {new Date(form?.created_time).getFullYear()}-
                                                                {String(new Date(form?.created_time).getMonth() + 1).padStart(2, '0')}-
                                                                {String(new Date(form?.created_time).getDate()).padStart(2, '0')}
                                                            </Text>
                                                        </Td>
                                                    </Tr>
                                                ))}
                                            </Tbody>
                                        </Table>
                                    </RadioGroup>
                                ) : (
                                    <Text fontSize="14px" color="gray.500">No form data available</Text>
                                )}
                            </>
                        ) : null}

                        {['WHATSAPP'].includes(adset?.destination_type) ? (
                            <>
                                <Flex>
                                    <Text fontWeight={'bold'}>Message template</Text>
                                </Flex>
                            
                                {(() => {
                                const welcomeData = formik?.values?.page_welcome_message;

                                const type = welcomeData?.text_format?.customer_action_type;

                                const greeting = welcomeData?.text_format?.message?.text || '';
                                const autofillMessage = welcomeData?.text_format?.message?.autofill_message?.content || '';
                                const iceBreakers = welcomeData?.text_format?.message?.ice_breakers || [];

                                return (
                                    <Box>
                                        <Box border={'1px solid'} borderColor={'gray.200'} p={2} borderRadius={'md'} bg={backgroundColor}>
                                            <Text fontSize={'14px'}><strong>Greeting:</strong> {greeting}</Text>

                                            {type === 'autofill_message' && (
                                                <Text fontSize={'14px'}><strong>Pre-filled message:</strong> {autofillMessage}</Text>
                                            )}

                                            {type === 'ice_breakers' && (
                                                <>
                                                <Text fontSize={'14px'}><strong>Frequently asked questions</strong></Text>
                                                {iceBreakers.map((q, i) => (
                                                    <Text key={i} fontSize="14px">
                                                    {i + 1}. {q.title}
                                                    </Text>
                                                ))}
                                                </>
                                            )}
                                        </Box>

                                        <Button
                                            variant="outline"
                                            backgroundColor="transparent" 
                                            size={'sm'}
                                            leftIcon={<MdOutlineEdit />}
                                            mt={2}
                                            onClick={() => {
                                                onMessageModalOpen();
                                            }}
                                        >
                                            Edit
                                        </Button>
                                    </Box>
                                );
                                })()}
                            </>
                        ) : null}

                        {["OUTCOME_AWARENESS", "OUTCOME_TRAFFIC", "OUTCOME_ENGAGEMENT", "OUTCOME_SALES", "OUTCOME_LEADS"].includes(campaign?.objective) &&  !['PHONE_CALL', 'APP', 'WHATSAPP'].includes(adset?.destination_type) ? 
                            <Flex direction="column" gap={1}>
                                <Text fontWeight="bold" >Display link</Text>
                                <Input
                                    name="caption"
                                    placeholder="Enter the link that you want to show on your ad"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.caption}
                                    onChange={formik.handleChange}
                                />
                            </Flex>
                        : null}

                        {campaign?.objective === "OUTCOME_AWARENESS" ? 
                            <Flex direction={'column'} gap={1}>
                                <Flex alignItems="center" gap={2}>
                                    <Text fontWeight="bold" >Mobile app</Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p="5px">
                                                <Text>Only select a mobile app if you are using a universal link (iOS or Android app link).</Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" />
                                    </Tooltip>
                                </Flex>
                                <Select
                                    name={`app_id`}
                                    bg="#fff"
                                    size="sm"
                                    borderRadius="md"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik?.values?.app_id}
                                >
                                    <option value="">Choose app</option>
                                    {advertisableApps?.map((option) => (
                                    <option key={option.id} value={option.id}>
                                        {option.name}
                                    </option>
                                ))}
                                </Select>
                            </Flex>
                        :null}
                    </Flex>

                    {['PHONE_CALL', 'ON_PAGE', 'APP', 'WHATSAPP'].includes(adset?.destination_type) ? null :
                        <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                            <Text fontWeight={'bold'}>Tracking</Text>
                            <Flex direction="column" gap={1}>
                                <Flex alignItems={'center'}>
                                    <Text mb={2} fontWeight="bold">
                                        URL parameters{" "}
                                        {/* <Text as="span" fontWeight="bold" color={'gray.600'} mr={1}>.</Text> */}
                                        <Text as="span" fontWeight="bold" color={'gray.600'}>Optional</Text>
                                    </Text>
                                    <Tooltip
                                        borderRadius={5}
                                        label={
                                            <Box fontSize="sm" p={'5px'}>
                                                <Text >
                                                    Add parameters to the end of your website URL to track where your visitors are coming from.
                                                </Text>
                                            </Box>
                                        }
                                        fontSize="md"
                                    >
                                        <InfoOutlineIcon pointerEvents="all" ml={2} mb={2} />
                                    </Tooltip>
                                </Flex>
                                <Input
                                    name="url_tags"
                                    placeholder="key1=value1&key2=value2"
                                    bg="#fff"
                                    size='sm'
                                    borderRadius="md"
                                    value={formik.values.url_tags}
                                    onChange={formik.handleChange}
                                />
                                <Flex mt={2}>
                                    <Button onClick={() => {
                                        setUrlParamModalOpen(true)
                                    }}
                                        variant="link"
                                        color='brand'>
                                        <Text fontSize={'12px'} >{'Build a URL parameter'}</Text>
                                    </Button>
                                </Flex>
                                {formik.touched?.url_tags && formik.errors?.url_tags && (
                                    <Text fontSize={"12px"} color="red.500">{formik.errors?.url_tags}</Text>
                                )}
                            </Flex>
                        </Flex>
                    }

                    <Flex direction={'column'} gap={2} borderRadius="md" bg={background} p={4} mb={4}>
                        <Flex direction="column" gap={1}>
                            <Text fontWeight="bold">CPA</Text>
                            <Input
                                name="cpa"
                                placeholder="Enter CPA"
                                size='sm'
                                borderRadius="md"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.cpa}
                            />
                        </Flex>
                    </Flex>

                    <Flex mb={2}>
                        <Button
                            size="sm"
                            colorScheme="brand"
                            isLoading={formik.isSubmitting}
                            type="submit"
                            isDisabled={!formik.isValid}
                        >
                            Save
                        </Button>
                    </Flex>
                </Flex>

                <Flex flex={0.6} px={4} direction={'column'} justifyContent={'space-between'} borderRadius={'md'} boxShadow="0 4px 6px rgba(0, 0, 0, 0.1), 0 1px 3px rgba(0, 0, 0, 0.08)">
                    <Flex py={2} gap={2} direction={'column'}>
                        <Flex py={2} gap={2}>
                            <Switch isChecked={isEnabled} colorScheme='brand' onChange={() => setIsEnabled(prevState => !prevState)} />
                            <Text fontWeight={'bold'} fontSize={'14px'}>Ad preview  </Text>
                        </Flex>
                        <Divider />
                        {isEnabled &&
                            <PublishAdPreviewCarousel placements={targeting} file={formik.values} adsAccountData={adsAccount} />
                        }
                    </Flex>
                    <Flex my={2} alignItems={'center'}>
                        <Text fontSize={'12px'} mr={2}>Ad rendering and interaction may vary based on device, format and other factors.</Text>
                        <Tooltip
                            borderRadius={5}
                            label={
                                <Box fontSize="12px" p="5px">
                                    <Text>
                                        Ads Manager previews are just examples and are not a substitute for reviewing Help Centre guidance and testing formats and devices to ensure that your ad delivers as intended.
                                    </Text>
                                </Box>
                            }
                            fontSize="md"
                        >
                            <InfoOutlineIcon pointerEvents="all" boxSize={3} />
                        </Tooltip>
                    </Flex>
                </Flex>
            </Flex>

            <Modal isOpen={isUrlModalOpen} onClose={() => setUrlModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <BuildUrlParamsUpdate link={formik.values} onClose={() => setUrlModalOpen(false)} onUrlChange={handleUrlChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isSingleUrlModalOpen} onClose={() => setSingleUrlModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <BuildUrlParamCarousel link={formik.values.adcreative} onClose={() => setSingleUrlModalOpen(false)} onUrlChange={handleSingleUrlChange} selectedFileIndex={selectedFileIndex} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Modal isOpen={isUrlParamModalOpen} onClose={() => setUrlParamModalOpen(false)} scrollBehavior={"inside"}
                size={"2xl"}
                isCentered={true}>
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader css={{ boxShadow: '0 0px 5px rgba(0, 0, 0, 0.1)' }}>Build a URL parameter</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        <UrlParametersUpdate link={formik.values} onClose={() => setUrlParamModalOpen(false)} onUrlChange={handleUrlParamChange} />
                    </ModalBody>
                </ModalContent>
            </Modal>

            <MessageTemplateModal
                isOpen={isMessageModalOpen}
                onClose={onMessageModalClose}
                accountId={''}
                welcomeData={formik.values?.page_welcome_message}
                onSave={(updatedData) => {
                    formik.setFieldValue('page_welcome_message', updatedData);
                    onMessageModalClose();
                }}
            />

            {/* Drive Modal */}
            <DriveModal
                isDriveModalOpen={isDriveModalOpen}
                selectedAdAccounts={[{
                    id: adsAccount._id,
                    adsAccountId: adsAccount.adsAccountId,
                    adsAccountName: adsAccount.adsAccountName,
                }]}
                onClose={() => setIsDriveModalOpen(false)}
                onSubmit={handleMediaSelect}
                uploadPurpose="update"
                mediaType={selectedMedia}
            />
        </form>
    );
};

export default CarouselPublishAdupdate;